// @ts-nocheck
import React, { useState } from 'react';
import SlideoutLayout from '../../../layout/slideout/SlideoutLayout';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import UserProfileGroupForm from '../components/UserProfileGroupForm';
import { saveUserProfileGroup } from '../../../../actions/userProfileGroupActions';
import { useTranslation } from 'react-i18next';
import Button from '../../../common/Button';

function AddUserGroup({ done, id, cancel }) {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
  } = useForm();

  const [userProfileGroup] = useState({});

  const onSubmit = (data) => {
    saveUserProfileGroup({ ...userProfileGroup, ...data })
      .then(() => {
        toast.success(t('Group saved'));
        done(userProfileGroup);
      })
      .catch(() => {
        toast.error(t('Failed to save group'));
      });
  };

  return (
    <SlideoutLayout
      title={id ? t('Edit group') : t('Add group')}
      cancel={cancel}
      done={done}
      bar={
        <Button
          type="submit"
          text={t('Save')}
          className="btn btn-primary"
          onClick={handleSubmit(onSubmit)}
          testId="save-user-group-button"
        />
      }
    >
      <UserProfileGroupForm
        userProfileGroup={userProfileGroup}
        register={register}
        errors={errors}
        control={control}
      />
    </SlideoutLayout>
  );
}

export default AddUserGroup;
